<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_STUFF_ADD"
            @click.stop="handleAdd()"
          >新增</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_STUFF_EDIT&&scope.row.status=='TO_BE_CONFIRMED'"
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="immediatePayment(scope.row.id)"
            v-if="scope.row.status=='WAIT_PAY'"
          >立即付款</el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="generateQRCode(scope.row.id)"
            v-if="scope.row.status=='TO_BE_RECEIVED'||scope.row.status=='WAITING_DELIVERY'"
          >提货码</el-button>
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="openDialogs(scope.row)"
          >查看</el-button>
        </template>

        <template slot-scope="scope" slot="supplierIdForm">
          <el-select
            v-model="department"
            placeholder="请供货商"
            @change="choseSupplier"
            required
            value-key="id"
          >
            <el-option
              v-for="department in departments"
              :key="department.id"
              :label="department.name"
              :value="department"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="addressForm">
          <el-input placeholder="请输入配送地址" v-model="address" :disabled="isShowAddress"></el-input>
        </template>
        <template slot-scope="scope" slot="provinceForm">
          <el-input type="input" name="title" :value="point.pname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="cityForm">
          <el-input type="input" name="title" :value="point.cityname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="areaForm">
          <el-input type="input" name="title" :value="point.adname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="provincesForm">
          <avue-map v-model="point"></avue-map>
        </template>
        <template slot-scope="scope" slot="distributionMode">
          <el-tag
            v-for="obj of distributionModes"
            :key="obj.value"
            v-if="obj.value == scope.row.distributionMode"
          >{{obj.label}}</el-tag>
        </template>
        <template slot-scope="scope" slot="status">
          <el-tag
            v-for="obj of supplyListStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
          >{{obj.label}}</el-tag>
        </template>
        <template slot-scope="scope" slot="distributionModeForm">
          <el-select
            v-model="distributionMode"
            placeholder="请选择配送方式"
            required
            @change="choseDistributionMode"
            value-key="value"
          >
            <el-option
              v-for="distributionMode in distributionModes"
              :key="distributionMode.value"
              :label="distributionMode.label"
              :value="distributionMode"
            ></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="goodsListForm">
          <div>
            <el-table :data="purchaseOrderGoodsList" border>
              <el-table-column prop="secondClassifyName" align="center" label="商品种类">
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="secondClassifyName"
                    :value="scope.row.goods.secondClassifyName"
                    disabled="disabled"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="name" align="center" label="商品名称">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.goods" placeholder="请选择商品" required value-key="id">
                    <el-option
                      v-for="goods in goodsList"
                      :key="goods.id"
                      :label="goods.name"
                      :value="goods"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="brand" align="center" label="商品品牌">
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="brand"
                    :value="scope.row.goods.brandName"
                    disabled="disabled"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="goodsNum" align="center" label="数量">
                <template slot-scope="scope">
                  <el-input type="input" v-model="scope.row.goods.goodsNum" name="goodsNum"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="price" align="center" label="单价">
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="price"
                    :value="scope.row.goods.merchantPrice"
                    disabled="disabled"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleGatherPlansDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
      </avue-crud>
      <template>
        <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
      <template>
        <el-dialog title="提货码" :visible.sync="GenerateQRCode" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-button @click="GenerateQRCode = false">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog
        title="进货单详情"
        :visible.sync="dialogVisible"
        width="50%"
        :data="dialog"
        style="background-color: #4E5465"
      >
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div class="grid-content bg-purple">进货单编号: {{dialog.supplyListNum}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div class="grid-content bg-purple">预约商: {{dialog.buyerName}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div class="grid-content bg-purple">联系人: {{dialog.contactsName}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div class="grid-content bg-purple">联系电话: {{dialog.contactsMobile}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div
              class="grid-content bg-purple"
              v-for="obj of distributionModes"
              :key="obj.value"
              v-if="obj.value == dialog.distributionMode"
            >
              配送方式:
              {{obj.label}}
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-col :span="8">
            <div class="grid-content bg-purple">供货商: {{dialog.supplierName}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px" v-if="dialog.distributionMode=='DELIVERY'">
          <el-col :span="8">
            <div class="grid-content bg-purple">配送地址: {{dialog.address}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px" v-if="dialog.distributionMode=='SELF_MENTION'">
          <el-col :span="8">
            <div class="grid-content bg-purple">自提地址: {{dialog.address}}</div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-table :data="dialog.goodsList" border>
            <el-table-column prop="secondClassifyName" align="center" label="商品种类">
              <template slot-scope="scope">
                <el-input
                  type="input"
                  name="secondClassifyName"
                  :value="scope.row.secondClassifyName"
                  disabled="disabled"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="商品名称">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.goods"
                  placeholder="请选择商品"
                  required
                  value-key="id"
                  disabled="disabled"
                >
                  <el-option
                    v-for="goods in goodsList"
                    :key="goods.id"
                    :label="goods.name"
                    :value="goods"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="brand" align="center" label="商品品牌">
              <template slot-scope="scope">
                <el-input
                  type="input"
                  name="brand"
                  :value="scope.row.brandName"
                  disabled="disabled"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="goodsNum" align="center" label="数量">
              <template slot-scope="scope">
                <el-input
                  type="input"
                  v-model="scope.row.goodsNum"
                  disabled="disabled"
                  name="goodsNum"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="discount" align="center" label="折扣比例">
              <template slot-scope="scope">
                <el-input
                  type="input"
                  v-model="scope.row.discount"
                  :disabled="isShowDiscount"
                  name="discount"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" label="单价">
              <template slot-scope="scope">
                <el-input
                  type="input"
                  name="price"
                  :value="scope.row.merchantPrice"
                  disabled="disabled"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" style="text-align: center">总计: {{dialog.totalPrice}}元</el-col>
        </el-row>
        <el-row :gutter="20" style="margin: 30px">
          <el-table :data="dialog.selectShop" v-if="dialog.status!='TO_BE_CONFIRMED'" border>
            <el-table-column prop="distributor" align="center" label="经销商">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.distributor"
                  placeholder="请选择经销商"
                  required
                  value-key="id"
                  :disabled="scope.row.isShow"
                >
                  <el-option
                    v-for="distributor in distributors"
                    :key="distributor.id"
                    :label="distributor.shopName"
                    :value="distributor"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              prop="costRatio"
              align="center"
              label="配送费比例"
              v-if="dialog.distributionMode=='DELIVERY'"
            >
              <template slot-scope="scope">
                <el-input
                  type="input"
                  v-model="scope.row.costRatio"
                  :disabled="scope.row.isShow"
                  name="costRatio"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="deliveryAddress"
              align="center"
              label="提货地址"
              v-if="dialog.distributionMode=='SELF_MENTION'"
            >
              <template slot-scope="scope">
                <el-input
                  type="input"
                  v-model="scope.row.deliveryAddress"
                  :disabled="scope.row.isShow"
                  name="deliveryAddress"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            v-if="dialog.status=='TO_BE_CONFIRMED'"
            @click.stop="handleReceipt(dialog)"
          >接单</el-button>
          <el-button
            type="primary"
            v-if="dialog.status=='STOCK_UP'"
            @click.stop="confirmDelivery(dialog)"
          >确认配送</el-button>
          <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
          <!--<el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { purchaseOrderOption } from "@/const/salesCloud/purchaseOrderOption";
import {
  findAllShopByUserId,
  findDistributionSheetDetailSupplyListById,
  findPurchaseOrder,
  addPurchaseOrder,
  editPurchaseOrder,
  findAllSuperiorDepartment,
  findGoodsList,
  findPurchaseOrderDetail,
  immediatePaySupplyList,
  generateQRCode,
  findDepartmentByUserId
} from "@/api/salesCloud/purchaseOrder";
// import {findByLabel} from "@/util/util"
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
export default {
  name: "purchaseOrder",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: purchaseOrderOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      departments: [],
      department: {},
      isShowAddress: false,
      distributionMode: {},
      distributionModes: DIC.DISTRIBUTION_MODE,
      goodsList: [],
      goods: {},
      purchaseOrderGoodsList: [],
      address: "",
      supplyListStatus: DIC.SUPPLY_LIST_STATUS,
      config: {},
      QRCodeDialog: false,
      GenerateQRCode: false,
      dialog: {},
      dialogVisible: false,
      point: {}
    };
  },
  created() {
    findAllSuperiorDepartment().then(res => {
      let data = JSON.parse(res.data);
      console.log("数据：" + res.data);
      this.departments = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    openDialogs(row) {
      this.dialog = {};
      let goodsList = [];
      let selectShop = [];
      findDepartmentByUserId(row.supplierId).then(res => {
        let data = JSON.parse(res.data);
        findGoodsList(data.id).then(res => {
          let data = JSON.parse(res.data);
          this.goodsList = data;
          findPurchaseOrderDetail(row.id).then(res => {
            let data = JSON.parse(res.data);
            let obj = data.rows[0].goodsList;
            for (let goods of obj) {
              for (let goods1 of this.goodsList) {
                if (goods.goodsId == goods1.id) {
                  let list = {};
                  list.discount = goods.discount;
                  list.goodsNum = goods.goodsNum;
                  list.supplyListGoodsId = goods.id;
                  list.secondClassifyName = goods1.secondClassifyName;
                  list.brandName = goods1.brandName;
                  list.merchantPrice = goods1.merchantPrice;
                  list.goods = goods1;
                  goodsList.push(list);
                }
              }
            }
            //this.purchaseOrderGoodsList=purchaseOrderGoodsList1;
          });
        });
      });

      if (row.status != "TO_BE_CONFIRMED") {
        this.isShowDiscount = true;
        // row.status=statusObj.label;
      } else {
        this.isShowDiscount = false;
      }
      if (row.status != "STOCK_UP") {
        row.isShow = true;
        findDistributionSheetDetailSupplyListById(row.id).then(res => {
          let data = JSON.parse(res.data);
          if (selectShop.length <= 0) {
            let list = {
              distributor: data.rows[0].distributorName,
              costRatio: data.rows[0].costRatio,
              deliveryAddress: "",
              isShow: row.isShow
            };
            selectShop.unshift(list);
          }
        });
      } else {
        if (selectShop.length <= 0) {
          let list = {
            costRatio: "",
            deliveryAddress: "",
            isShow: row.isShow
          };
          selectShop.unshift(list);
        }
      }
      findAllShopByUserId(row.supplierId).then(res => {
        let data = JSON.parse(res.data);
        this.distributors = data;
      });
      this.dialog = row;
      this.dialog.goodsList = goodsList;
      this.dialog.selectShop = selectShop;
      this.dialogVisible = true;
    },
    handleGatherPlansDelete(index, row) {
      this.purchaseOrderGoodsList.splice(index, 1);
    },
    handleAddRows() {
      let list = {
        goods: {
          secondClassifyName: "",
          brandName: "",
          merchantPrice: 0
        }
      };
      this.purchaseOrderGoodsList.unshift(list);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findPurchaseOrder(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findPurchaseOrder(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findPurchaseOrder(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findPurchaseOrder(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    choseDistributionMode() {
      if (this.distributionMode.value == "SELF_MENTION") {
        this.isShowAddress = true;
      } else {
        this.isShowAddress = false;
      }
    },
    choseSupplier() {
      findGoodsList(this.department.id).then(res => {
        let data = JSON.parse(res.data);
        console.log("商品：" + res.data);
        this.goodsList = data;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      let purchaseOrderGoodsList1 = [];
      for (let obj of this.distributionModes) {
        if (obj.value == row.distributionMode) {
          this.distributionMode = obj;
        }
      }
      for (let obj of this.departments) {
        if (obj.dutyStuff == row.supplierId) {
          this.department = obj;
        }
      }

      findGoodsList(this.department.id).then(res => {
        let data = JSON.parse(res.data);
        console.log("商品：" + row.supplierId);
        this.goodsList = data;
      });

      findPurchaseOrderDetail(row.id).then(res => {
        let data = JSON.parse(res.data);
        let obj = data.rows[0].goodsList;
        console.log("商品：" + JSON.stringify(obj));
        for (let goods of obj) {
          for (let goods1 of this.goodsList) {
            if (goods.goodsId == goods1.id) {
              goods1.goodsNum = goods.goodsNum;
              purchaseOrderGoodsList1.push({ goods: goods1 });
            }
          }
        }

        this.purchaseOrderGoodsList = purchaseOrderGoodsList1;
      });
      //this.purchaseOrderGoodsList.row=row;
      this.address = row.address;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findPurchaseOrder(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log("集合：" + JSON.stringify(this.purchaseOrderGoodsList));
      let goodsList = [];
      for (let objArray of this.purchaseOrderGoodsList) {
        let obj = {};
        obj.goodsNum = objArray.goods.goodsNum;
        obj.goodsId = objArray.goods.id;
        goodsList.push(obj);
      }
      row.address = this.address;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.supplierId = this.department.dutyStuff;
      row.distributionMode = this.distributionMode.value;
      row.goodsList = goodsList;
      addPurchaseOrder(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },

    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log("集合：" + JSON.stringify(this.purchaseOrderGoodsList));
      let goodsList = [];
      for (let objArray of this.purchaseOrderGoodsList) {
        let obj = {};
        obj.goodsNum = objArray.goods.goodsNum;
        obj.goodsId = objArray.goods.id;
        goodsList.push(obj);
      }
      row.address = this.address;
      row.supplierId = this.department.dutyStuff;
      row.distributionMode = this.distributionMode.value;
      row.goodsList = goodsList;
      editPurchaseOrder(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    immediatePayment(id) {
      immediatePaySupplyList(id).then(res => {
        // let data = JSON.parse(res.data);
        this.config.value = res.data.codeUrl;
        console.log("集合：" + this.config.value);
        this.QRCodeDialog = true;
      });
    },
    generateQRCode(id) {
      generateQRCode(id).then(res => {
        let data = JSON.parse(res.data);
        console.log("集合：" + data);
        this.config.value = data.url;
        console.log("集合：" + this.config.value);
        this.GenerateQRCode = true;
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
